import React from "react";
const TorExitNodeAdapterFieldSet = () => /* @__PURE__ */ React.createElement("fieldset", null);
export default TorExitNodeAdapterFieldSet;
